export default {
    dashboard: {
        totalWordsGenerated: 'Total de mots générés',
        wordsPerDay: 'Mots/jour',
        content: 'Contenu',
        date: 'Date',
        variationCount: 'Nombre de variations',
        transactionId: 'Identifiant de transaction',
        totalWordsCount: 'Nombre total de mots',
        action: 'Action',
        goTo: 'Aller à',
        viewMore: 'Voir plus',
        showLess: 'Montrer moins',
        tabImage: 'Image',
        tabText: 'Texte',
        dashboardSubtitle: "Gérez votre contenu généré par l'IA",
        type: 'Type',
    },
};
